/**
 * True when `short` adds nothing over `full`: it is empty, the same text, or a
 * cut-off copy of the start of `full` (feeds often truncate the full
 * description mid-word, e.g. "...the river oasis or the uniq"). Showing both
 * prints the same paragraph twice, the first copy broken.
 */
export function isRedundantTeaser(short: string | null | undefined, full: string | null | undefined): boolean {
  const norm = (s: string) =>
    s
      .replace(/<[^>]*>/g, ' ')
      .replace(/&nbsp;/g, ' ')
      .replace(/(\.\.\.|…)\s*$/, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  const s = norm(short || '');
  const f = norm(full || '');
  if (!s) return true;
  if (!f) return false;
  return f === s || f.startsWith(s);
}
